import classNames from 'classnames';
import { error } from '../_util/devConsoleLog';
import { useMemo } from 'react';
import './style/index';
import { jsx as _jsx } from "react/jsx-runtime";
const svgBaseProps = {
  width: '1em',
  height: '1em',
  fill: 'currentColor'
  //'aria-hidden': 'true',
  //focusable: 'false',
};
const reqAttrs = ['viewBox'];
const renameTheId = svgstr => {
  let svgContent = svgstr;
  const uniqueIdPrefix = "svg-".concat(Math.random().toString(36).substr(2, 9), "-");

  // 收集所有的 ID
  const idMap = new Map();
  const idRegex = /\bid\s*=\s*["']([^"']+)["']/g;
  let idMatch;
  while ((idMatch = idRegex.exec(svgContent)) !== null) {
    const originalId = idMatch[1];
    if (!idMap.has(originalId)) {
      idMap.set(originalId, "".concat(uniqueIdPrefix).concat(originalId));
    }
  }

  // 替换所有的 ID 定义
  idMap.forEach((newId, originalId) => {
    const idDefRegex = new RegExp("\\bid\\s*=\\s*[\"']".concat(originalId.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "[\"']"), 'g');
    svgContent = svgContent.replace(idDefRegex, "id=\"".concat(newId, "\""));
  });

  // 替换所有的 ID 引用（xlink:href, href, url() 等）
  idMap.forEach((newId, originalId) => {
    // 替换 xlink:href="#id" 格式
    const xlinkHrefRegex = new RegExp("xlink:href\\s*=\\s*[\"']#".concat(originalId.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "[\"']"), 'g');
    svgContent = svgContent.replace(xlinkHrefRegex, "xlink:href=\"#".concat(newId, "\""));

    // 替换 href="#id" 格式
    const hrefRegex = new RegExp("href\\s*=\\s*[\"']#".concat(originalId.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "[\"']"), 'g');
    svgContent = svgContent.replace(hrefRegex, "href=\"#".concat(newId, "\""));

    // 替换 url(#id) 格式
    const urlRegex = new RegExp("url\\(#".concat(originalId.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "\\)"), 'g');
    svgContent = svgContent.replace(urlRegex, "url(#".concat(newId, ")"));
  });
  return svgContent;
};
const processSvgString = svgStr => {
  let trimmedSvg = svgStr.trim();
  trimmedSvg = renameTheId(trimmedSvg);
  let svgAttrs = {};
  trimmedSvg = trimmedSvg.replace(/^<\?xml[\s\S]*?\?>\s*/i, '');
  if (trimmedSvg.startsWith('<svg')) {
    // 提取 svg 标签属性
    const tagMatch = trimmedSvg.match(/^<svg\s+([^>]*)>/i);
    if (tagMatch && tagMatch[1]) {
      // 匹配所有属性对
      const attrRegex = /(\w[\w:-]*)\s*=\s*(["'])(.*?)\2/g;
      let match;
      while ((match = attrRegex.exec(tagMatch[1])) !== null) {
        if (reqAttrs.includes(match[1])) {
          svgAttrs[match[1]] = match[3];
        }
      }
    }
    // 提取 svg 内容
    const contentMatch = trimmedSvg.match(/<svg[^>]*>([\s\S]*)<\/svg>/i);
    if (contentMatch) {
      return {
        svgContent: contentMatch[1],
        svgAttrs
      };
    }
  }
  return {
    svgContent: trimmedSvg,
    svgAttrs
  };
};
const SvgIcon = props => {
  const {
    svgStr,
    spin,
    block,
    rotate,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-svgIcon");
  error(!svgStr, 'Icon', 'The “svg” parameter must have');
  const {
    svgContent,
    svgAttrs
  } = useMemo(() => processSvgString(svgStr), [svgStr]);
  return /*#__PURE__*/_jsx("svg", {
    ...svgAttrs,
    ...svgBaseProps,
    ...restProps,
    className: classNames(className, baseClassName, {
      ["".concat(baseClassName, "-anticon-spin")]: !!spin
      //  || TODO
      // svg === 'LoadingOutlined' ||
      // svg === 'Loading3QuartersOutlined',
    }),
    style: {
      ...style,
      ...(block ? {
        display: 'block'
      } : {}),
      ...(rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
      } : {})
    },
    dangerouslySetInnerHTML: {
      __html: svgContent
    }
  });
};
export default SvgIcon;